import { getStatusClass } from './AccountHealth/AccountHealth';
import styles from './AccountHealth/AccountHealth.module.scss';

export const healthData = [
    {
        id: 1,
        metric: 'Order Defect Rate (ODR)',
        target: '<1%',
        value: '0.5%',
        status: 'Good',
    },
    {
        id: 2,
        metric: 'Order Defect Rate (ODR)',
        target: '<1%',
        value: '0.5%',
        status: 'Good',
    },
    {
        id: 3,
        metric: 'Order Defect Rate (ODR)',
        target: '<1%',
        value: '0.5%',
        status: 'Good',
    },
    {
        id: 4,
        metric: 'Order Defect Rate (ODR)',
        target: '<1%',
        value: '0.5%',
        status: 'At Risk',
    },
];

export const healthColumns = [
    {
        name: 'Metric',
        selector: (row) => row.metric,
        sortable: true,
        width: '220px',
    },
    {
        name: 'Target',
        selector: (row) => row.target,
        sortable: true,
    },
    {
        name: 'Current Value',
        selector: (row) => row.value,
        sortable: true,
    },
    {
        name: 'Status',
        selector: (row) => row.status,
        cell: (row) => (
            <span className={`${styles.status} ${getStatusClass(row.status)}`}></span>
        ),
        sortable: true,
    },
];

export const healthStyles = {
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "16px",
            paddingRight: "16px",
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '16px',
        },
    },
};

export const policyData = [
    {
        id: 1,
        violationType: 'Late Shipment',
        date: '27/07/2024',
        action: 'Review Shipping Process',
        status: 'Pending',
    },
    {
        id: 2,
        violationType: 'Product Description',
        date: '26/07/2024',
        action: 'N/A',
        status: 'Resolved',
    },
    {
        id: 3,
        violationType: 'Product Description',
        date: '26/07/2024',
        action: 'N/A',
        status: 'Resolved',
    },
];

export const policyColumns = [
    {
        name: "Violation Type",
        selector: (row) => row.violationType,
    },
    {
        name: "Date",
        selector: (row) => row.date,
    },
    {
        name: "Action Required",
        selector: (row) => row.action,
    },
    {
        name: "Status",
        cell: (row) => <span className={getStatusClass(row.status)}>{row.status}</span>,
    },
];

export const policyStyles = {
    header: {
        style: {
            fontSize: '15px',
            padding: '0',
            fontWeight: '400',
        },
    },
    table: {
        style: {
            border: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            fontSize: '15px',
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '20px',
        },
    },
};

export const orderContent = [
    { heading: "Order Limit", content: "200 per day" },
    { heading: "Remaining Orders Limits", content: "170" },
];


/* ------------------------------------- Policies ----------------------------------------- */

export const policyGuidelineData = [
    {
        id: 1,
        message: 'Product Listing',
        description: 'Guidelines on how to list products correctly.',
        detailsLink: 'View Details',
    },
    {
        id: 2,
        message: 'Pricing Policy',
        description: 'Rules regarding product pricing and discounts.',
        detailsLink: 'View Details',
    },
    {
        id: 3,
        message: 'Return Policy',
        description: 'Requirements for handling returns and refunds.',
        detailsLink: 'View Details',
    },
];

export const policyGuidelineColumns = [
    {
        name: "Message",
        selector: (row) => row.message,
    },
    {
        name: "Description",
        selector: (row) => row.description,
        grow: 2,
    },
    {
        name: "Link to Details",
        cell: (row) => <span style={{ color: '#EC7426' }}>{row.detailsLink}</span>,
    },
];

export const industrialContent = [
    { heading: "Safety Standards", content: "Ensure your products are safe for use" },
    { heading: "Quality Standards", content: "Maintain high-quality production processes" },
];

export const legalContent = [
    { heading: "Tax Obligations", content: "Ensure you correctly report and pay taxes" },
    { heading: "Consumer Rights", content: "Respect the rights of your customers regarding returns and refunds" },
];

export const contactSupportData = [
    {
        title: 'Email',
        details: [
            { label: 'Support Email', value: 'support@maelano.com' },
            { label: 'Response Time', value: 'Typically within 24-48 hours' },
        ],
    },
    {
        title: 'Phone',
        details: [
            { label: 'Support Phone Number', value: '+1-810-123-4567' },
            { label: 'Availability', value: 'Monday to Friday, 9 AM to 5 PM (Local Time)' },
        ],
    },
];
